import { render, staticRenderFns } from "./look-over-detail.vue?vue&type=template&id=2932b942&scoped=true"
import script from "./look-over-detail.vue?vue&type=script&lang=js"
export * from "./look-over-detail.vue?vue&type=script&lang=js"
import style0 from "./look-over-detail.vue?vue&type=style&index=0&id=2932b942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932b942",
  null
  
)

export default component.exports